/**
 * ============================================
 * UCM - Ultra Car Manager
 * Storefront - Main App Component (Premium Showroom)
 * © 2024 AlbaSoft Studio - All Rights Reserved
 * ============================================
 */

import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import PublicLayout from './components/layout/PublicLayout';

// Lazy load pages for better performance
const ShowroomHomePage = lazy(() => import('./pages/ShowroomHomePage'));
const ShowroomCatalogPage = lazy(() => import('./pages/ShowroomCatalogPage'));
const RentalPage = lazy(() => import('./pages/RentalPage'));
const SalePage = lazy(() => import('./pages/SalePage'));
const VehicleDetailPage = lazy(() => import('./pages/VehicleDetailPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-slate-600 text-lg">Caricamento...</p>
    </div>
  </div>
);

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<ShowroomHomePage />} />
          <Route path="/vetrina" element={<ShowroomHomePage />} />
          <Route path="/vetrina/catalogo" element={<ShowroomCatalogPage />} />
          <Route path="/vetrina/noleggio" element={<RentalPage />} />
          <Route path="/vetrina/vendita" element={<SalePage />} />
          <Route path="/vetrina/veicolo/:id" element={<VehicleDetailPage />} />
          <Route path="/vetrina/contatti" element={<ContactPage />} />
          <Route path="/vetrina/chi-siamo" element={<AboutPage />} />
          <Route path="/vetrina/servizi" element={<ServicesPage />} />
          <Route path="/vetrina/servizi/:serviceId" element={<ServicesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
